import {
    apiBot, queryMany, queryBot2, nodeback,
} from 'boot/axios';
import { isFlowVisible } from 'src/model/helpers';
import starsService from 'src/services/stars.service';
import { parseJson } from 'src/mixins/utils';

const resultService = {
    userId: undefined,
    init: (userId) => {
        resultService.userId = userId;
    },
    // Отметить тему выполненной и пересчитать прогресс по модулю и курсу
    setPassed: async (slideId, success, source = 'lms', result = 0) => {
        const { userId } = resultService;
        // console.trace('userId', userId, 'slideId', slideId, 'success', success, 'result score', result);
        const response = await apiBot.get(`setTaskFinished.php?userId=${userId}&slideId=${slideId}&success=${success ? '1' : '0'}&source=${source}&result=${result}`);
        const { data } = response;
        await starsService.updateUserStars(userId);
        const attestationFinished = await resultService.updateTaskResult(data.taskId, userId);
        return data?.finished === 'true' && attestationFinished;
        // await queryBot2('set-task-passed', { userId, taskId, passed });
    },

    // Безусловно отметить тему выполненной и пересчитать прогресс по модулю и курсу
    setPassedForce: async (taskId, source = 'lms', userId = undefined) => {
        if (userId === undefined) userId = resultService.userId;
        const response = await apiBot.get(`setTaskFinished.php?userId=${userId}&taskId=${taskId}&success=1&source=${source}`);
        const { data } = response;
        return data?.finished === 'true';
    },

    // отметить тему выполненной и пересчитать прогресс по модулю и курсу
    setPassedByUser: async (userId, taskId, source = 'lms', passed = true) => {
        // console.log(`setTaskFinished.php?userId=${userId}&taskId=${taskId}&calcProgress=1&source=${source}&passed=${passed ? '1' : '0'}`);
        await apiBot.get(`setTaskFinished.php?userId=${userId}&taskId=${taskId}&calcProgress=1&source=${source}&passed=${passed ? '1' : '0'}`);
        resultService.userId = userId;
        if (passed) {
            await resultService.updateTaskResult(taskId, userId);
        }
    },

    async updateUserVisitsCache (context, user, courseId) {
        const flowNum = await context.$db.tasks.getUserCourseFlowNum(user.id, courseId);
        const tasks = (await queryMany(`
            select
                tasks.id,
                tasks.title,
                tasks.visible_for_flows,
                tasks.superModuleNum
            from
                tasks
            inner join modules on modules.id = tasks.module_id
            where
                tasks.course_id = '${courseId}'
                and
                tasks.sending_allowed = '1'
                and
                modules.is_entrance_testing <> '1'
        `)).filter((t) => isFlowVisible(flowNum, t.visible_for_flows, user.hashtags));
        // сравнить с user_tasks_visits
        const visits = await queryMany(`select * from user_tasks_visits where userId = '${user.id}' and courseId = '${courseId}'`);

        // добавить новые темы в кеш
        for (let i = 0; i < tasks.length; i += 1) {
            const [v] = visits.filter((j) => j.taskId === tasks[i].id);
            if (!v) {
                // eslint-disable-next-line no-await-in-loop
                await context.$db.insertObject('user_tasks_visits', {
                    userId: user.id,
                    courseId,
                    moduleNum: tasks[i].superModuleNum,
                    taskId: tasks[i].id,
                    isVisited: 0,
                    passed: 0,
                });
            }
        }

        // удалить темы из кеша, которые больше не видны клиенту
        for (let i = 0; i < visits.length; i += 1) {
            const [t] = tasks.filter((j) => j.id === visits[i].taskId);
            if (!t) {
                // eslint-disable-next-line no-await-in-loop
                await queryMany(`delete from user_tasks_visits where id = '${visits[i].id}'`);
            }
        }
    },

    async updateTaskResult (taskId, userId) {
        let result = true;
        let response = await queryBot2('get-task-questions', { taskId });
        const questions = response.data;
        const r = await queryBot2('get-user-by-id', { id: userId });
        const user = r.data[0];
        response = await queryBot2('get-user-flow-num', {
            userId: user.id,
            courseId: user.last_course_id,
        });
        const flowNum = response.data[0]?.flow_num;

        const checkQuestions = [];
        for (let i = 0; i < questions.length; i += 1) {
            const q = questions[i];
            q.question = JSON.parse(q.question);

            if (['questions', 'interactive', 'exercise', 'SQLexercise', 'CodeExercise', 'portfolio'].includes(q.question.type) && q.question.selfCheck !== '1') {
                const visibility = parseJson(q.visibility_json);
                const { flows } = visibility;
                if (flows) {
                    if (isFlowVisible(flowNum, flows, user.hashtags)) checkQuestions.push(q);
                } else {
                    checkQuestions.push(q);
                }
            }
        }
        // console.log('updateTaskResult init params', flowNum, user.hashtags, questions, checkQuestions);
        response = await queryBot2('get-slides-score', {
            taskId,
            userId: user.id,
        });
        const slidesScore = response.data;
        let sum = 0;
        let sumStars = 0;
        let countResults = 0;
        _.each(checkQuestions, (q) => {
            const resultItem = _.find(slidesScore, (item) => item.slideId === q.id && item.success !== '2');
            if (resultItem) {
                const k = _.isNull(q.stars) ? 1 : +q.stars;
                sum += +resultItem.result * k;
                sumStars += k;
                countResults += 1;
                q.successResult = +resultItem.success;
            } else if (q.question.requiredAnswer === '1') {
                sum = -1;
                return false;
            } else {
                sumStars += _.isNull(q.stars) ? 1 : +q.stars;
            }
            return true;
        });
        let score = 0;
        if (sum > 0) {
            score = sum / sumStars;
            score = score.toFixed(0);
        }
        const countRequiredAnswer = _.filter(checkQuestions, q => q.question.requiredAnswer === '1').length;
        const countRequiredAnswerWithoutResult = _.filter(checkQuestions, q => q.question.requiredAnswer === '1' && !_.isNumber(q.successResult)).length;

        if ((countRequiredAnswer > 0 && countRequiredAnswerWithoutResult === 0) || (countRequiredAnswer === 0 && countResults > 0)) {
            const rs = await queryBot2('get-task', { taskId });
            const task = rs.data[0];

            const countRequiredAnswerWithoutIncorrectResult = _.filter(checkQuestions, q => q.question.requiredAnswer === '1' && !q.successResult).length;
            await queryBot2('remove-compl-tasks', {
                taskId,
                userId: user.chat_id,
            });
            // console.error('insert-compl-task', taskId, user.chat_id, score);

            await queryBot2('insert-compl-task', {
                taskId,
                chatId: user.chat_id,
                result: Number((countRequiredAnswer > 0 && countRequiredAnswerWithoutIncorrectResult === 0) || (countRequiredAnswer === 0 && countResults > 0)),
                score,
            });

            if (+task.attestation === 1) {
                result = false;
                const { superModuleNum } = task;
                const type = `attestatScoreModule${superModuleNum}`;
                const value = JSON.stringify({
                    taskId: task.id,
                    score,
                });
                await queryBot2('insert-users_cache', {
                    userId: user.id,
                    type,
                    value,
                });
                if (score >= +task.success_score && countRequiredAnswerWithoutIncorrectResult === 0) {
                    // console.log('set passed task', task, +task.success_score, score);
                    await resultService.setPassedForce(taskId, 'res_service', user.id);
                    result = true;
                }
                if (!result) {
                    await queryBot2('set-task-passed', { userId: user.id, taskId, passed: 0 });
                }
            }

            if (+task.isFinalAttestation === 1) {
                result = false;
                const type = 'attestatScoreFinal';
                const value = JSON.stringify({
                    courseId: this.courseId,
                    taskId: task.id,
                    score,
                });
                await queryBot2('insert-users_cache', {
                    userId: user.id,
                    type,
                    value,
                });
                if (score >= +task.success_score && countRequiredAnswerWithoutIncorrectResult === 0) {
                    // console.log('set passed task', task);
                    await resultService.setPassedForce(taskId, 'res_service', user.id);
                    result = true;
                }
                if (!result) {
                    await queryBot2('set-task-passed', { userId: user.id, taskId, passed: 0 });
                }
            }
        }
        return result;
    },

    /**
     * Отправка уведомлений по аттестациям
     * @param userId - обязательно, users.id
     * @param tgId - users.tgChatId
     * @param email - users.email
     * @param timeZone - обязательно, users.timeZone
     * @param attestationType - attestation || final
     * @param moduleName - обязательно, tasks.title
     * @param courseName - обязательно, courses.title
     * @returns {Promise<axios.AxiosResponse<any>|boolean>}
     */
    async sendNotificationOnAttestationStatusChanged (userId, tgId = '', email = '', timeZone = '+03:00', attestationType, moduleName = '', courseName = '') {
        if (!userId) return false;

        const url = '/api/v1/notification/queue';
        const data = new FormData();

        data.append('userId', userId);
        data.append('tgId', tgId);
        data.append('email', email);
        data.append('timeZone', timeZone);
        data.append('forceEmail', 1);

        let text = '';
        let subject = '';

        switch (attestationType) {
            case 'attestation':
                text = `Поздравляем! Вы успешно прошли аттестацию по модулю «${moduleName}».`;
                subject = 'Поздравляем c успешным прохождением промежуточной аттестации!';
                break;
            case 'final':
                text = 'Поздравляем c успешным прохождением итоговой аттестации!';
                subject = `Поздравляем! Вы успешно прошли итоговую аттестацию и завершили обучение по курсу «${courseName}».`;
                break;
            default:
                return false;
        }

        data.append('text', text);
        data.append('subject', subject);

        return await nodeback.post(url, data);
    },
};

export default resultService;
